/**
 * 定义路径s
 */
const PATH = 'nav_'
/*
包含n个mutation的type名称常量
 */
export const NAV_DELETE = PATH + 'delete'
export const NAV_CHANGE = PATH + 'change'
export const NAV_APPEND = PATH + 'append'
export const NAV_PREPEND_NAME_BY_PATH = PATH + 'prenend_name_by_path'
export const NAV_APPEND_AND_CLOSE = PATH + 'append_and_close'
export const NAV_BACK_CHANGE = PATH + 'back_change'



// WEBPACK FOOTER //
// ./src/store/mutations/nav/type.js